export const palette = {
  light: {
    bg: '#FAFAFA',
    surface: '#FFFFFF',
    surfaceAlt: '#F4F4F5',
    primary: '#0A0A0A',
    onPrimary: '#FFFFFF',
    text: '#0A0A0A',
    muted: '#71717A',
    border: '#E4E4E7',
    accent: '#0A0A0A',
    success: '#27272A',
    error: '#EF4444',
  },
  dark: {
    bg: '#09090B',
    surface: '#121214',
    surfaceAlt: '#1C1C1F',
    primary: '#FAFAFA',
    onPrimary: '#09090B',
    text: '#FAFAFA',
    muted: '#A1A1AA',
    border: '#27272A',
    accent: '#FAFAFA',
    success: '#FAFAFA',
    error: '#F87171',
  },
} as const;

export type Theme = typeof palette.light;

export const fonts = {
  serif: 'CormorantGaramond_500Medium',
  serifBold: 'CormorantGaramond_600SemiBold',
  sans: 'System',
};

export const radius = { sm: 8, md: 12, lg: 16, xl: 20, pill: 999 };
export const spacing = { xs: 4, sm: 8, md: 16, lg: 24, xl: 32, xxl: 48 };
